var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-toast',{attrs:{"variant":_vm.message.category,"id":_vm.message.id,"title":_vm.message.title,"toaster":"b-toaster-bottom-left"},on:{"hidden":_vm.deleteMessage},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('p',[_vm._v(_vm._s(_vm.message.body))])])
}
var staticRenderFns = []

export { render, staticRenderFns }